import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-tariffs-info',
  imports: [MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatIconModule,TranslatePipe],
  templateUrl: './tariffs-info.html',
  styleUrl: './tariffs-info.scss'
})
export class TariffsInfo implements OnInit{
  
  readonly dialogRef = inject(MatDialogRef<TariffsInfo>);
  readonly data = inject(MAT_DIALOG_DATA);


  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  onNoClick(){
    this.dialogRef.close();
  }

  clickIconClose(event: MouseEvent){
      this.onNoClick();
  }
}
